import * as internal from "./internal/httpServerResponse.js";
/**
 * @since 1.0.0
 * @category type ids
 */
export const TypeId = /*#__PURE__*/Symbol.for("@effect/platform/HttpServerResponse");
/**
 * @since 1.0.0
 */
export const isServerResponse = internal.isServerResponse;
/**
 * @since 1.0.0
 * @category constructors
 */
export const empty = internal.empty;
/**
 * @since 1.0.0
 * @category constructors
 */
export const redirect = internal.redirect;
/**
 * @since 1.0.0
 * @category constructors
 */
export const uint8Array = internal.uint8Array;
/**
 * @since 1.0.0
 * @category constructors
 */
export const text = internal.text;
/**
 * @since 1.0.0
 * @category constructors
 */
export const html = internal.html;
/**
 * @since 1.0.0
 * @category constructors
 */
export const htmlStream = internal.htmlStream;
/**
 * @since 1.0.0
 * @category constructors
 */
export const json = internal.json;
/**
 * @since 1.0.0
 * @category constructors
 */
export const schemaJson = internal.schemaJson;
/**
 * @since 1.0.0
 * @category constructors
 */
export const unsafeJson = internal.unsafeJson;
/**
 * @since 1.0.0
 * @category constructors
 */
export const urlParams = internal.urlParams;
/**
 * @since 1.0.0
 * @category constructors
 */
export const raw = internal.raw;
/**
 * @since 1.0.0
 * @category constructors
 */
export const formData = internal.formData;
/**
 * @since 1.0.0
 * @category constructors
 */
export const stream = internal.stream;
/**
 * @since 1.0.0
 * @category constructors
 */
export const file = internal.file;
/**
 * @since 1.0.0
 * @category constructors
 */
export const fileWeb = internal.fileWeb;
/**
 * @since 1.0.0
 * @category combinators
 */
export const setHeader = internal.setHeader;
/**
 * @since 1.0.0
 * @category combinators
 */
export const setHeaders = internal.setHeaders;
/**
 * @since 1.0.0
 * @category combinators
 */
export const removeCookie = internal.removeCookie;
/**
 * @since 1.0.0
 * @category combinators
 */
export const replaceCookies = internal.replaceCookies;
/**
 * @since 1.0.0
 * @category combinators
 */
export const setCookie = internal.setCookie;
/**
 * @since 1.0.0
 * @category combinators
 */
export const unsafeSetCookie = internal.unsafeSetCookie;
/**
 * @since 1.0.0
 * @category combinators
 */
export const updateCookies = internal.updateCookies;
/**
 * @since 1.0.0
 * @category combinators
 */
export const mergeCookies = internal.mergeCookies;
/**
 * @since 1.0.0
 * @category combinators
 */
export const setCookies = internal.setCookies;
/**
 * @since 1.0.0
 * @category combinators
 */
export const unsafeSetCookies = internal.unsafeSetCookies;
/**
 * @since 1.0.0
 * @category combinators
 */
export const setBody = internal.setBody;
/**
 * @since 1.0.0
 * @category combinators
 */
export const setStatus = internal.setStatus;
/**
 * @since 1.0.0
 * @category conversions
 */
export const toWeb = internal.toWeb;
//# sourceMappingURL=HttpServerResponse.js.map